import css from "./ToggleSwitch.module.css";

function ToggleSwitch(props) {
  function onChange() {
    props.setToggleBool(!props.toggleBool);
  }
  return (
    <div className={css.switchContainer}>
      <h4 className={css.label}>{props.label}</h4>
      <label className={css.switch}>
        <input
          id={props.id}
          className={css.input}
          type="checkbox"
          onChange={onChange}
        />
        <span className={css.sliderRound}></span>
      </label>
    </div>
  );
}

export default ToggleSwitch;
